import { inject, Injectable } from "@angular/core";
import { rxResource, toSignal } from "@angular/core/rxjs-interop";
import { fromEvent, of } from "rxjs";
import { catchError, startWith } from "rxjs/operators";
import { SiteFonctionnalite } from "@jack-sparrow-libraries/emotion-models";
import { EmotionAngularEvents } from "src/app-ay/core/services/emotion-events.service";
import { IndicateursApi } from "./indicateurs.api";
import { Store } from "@ngrx/store";
import { AppState, selectFullClient } from "features";

@Injectable()
export class IndicateursFacadeService {
	private readonly indicateursApiService = inject(IndicateursApi);
	private readonly store = inject(Store<AppState>);

	private readonly refreshRejetsCount$ = fromEvent(window, EmotionAngularEvents.ANGULAR_RELOAD_REJETS_COUNT).pipe(
		startWith(void 0),
	);

	private readonly $fullClient = this.store.selectSignal(selectFullClient);
	private readonly $refreshRejetsCount = toSignal(this.refreshRejetsCount$);

	/**
	 * Resource exposant les indicateurs de rejets GP bruts pour le client courant.
	 * `value()` vaut `null` si le client n'a pas la permission `PaiementGaranti` ou en cas d'erreur,
	 * et `undefined` tant qu'aucun client n'est chargé.
	 * Le stream est re-déclenché à chaque événement `ANGULAR_RELOAD_REJETS_COUNT` via `$refreshRejetsCount`.
	 */
	readonly $indicateursResourceRef = rxResource({
		params: () => {
			const fullClient = this.$fullClient();
			if (!fullClient) {
				return undefined;
			}
			return { fullClient, refresh: this.$refreshRejetsCount() };
		},
		stream: ({ params: { fullClient } }) => {
			if (!fullClient.permissions.includes(SiteFonctionnalite.PaiementGaranti)) {
				return of(null);
			}
			return this.indicateursApiService
				.getIndicateursRejetsATraiter(fullClient.idSituation)
				.pipe(catchError(() => of(null)));
		},
	});
}
